import {Row} from "@tanstack/react-table";
import {columnTypes} from "@/features/types/AutoTableFilterInterface";
import {autoTableColumnLabels} from "@/features/i18n/autoTableColumns";

export type FlatItem = { type: "row"; row: Row<AutoTableInterface> } | { type: "detail"; row: Row<AutoTableInterface> };

export type DataColumn = {
    accessorKey: keyof AutoTableInterface;
    header: string;
    type?: columnTypes;
    size?: number;
};

// TUTAJ MOŻNA DOSTOSOWAĆ COLUMN SIZE W PIKSELACH
export const columns: DataColumn[] = [
    {accessorKey: "f_vis_mark_7", header: autoTableColumnLabels.f_vis_mark_7, type: 'boolean', size: 50},
    {accessorKey: "f_loc_lit", header: autoTableColumnLabels.f_loc_lit, type: 'select', size: 70},
    {accessorKey: "f_supp_2_doc_invc_o_diff", header: autoTableColumnLabels.f_supp_2_doc_invc_o_diff, type: 'numberInput', size: 70},
    {accessorKey: "f_ord_num", header: autoTableColumnLabels.f_ord_num, type: 'select', size: 90},
    {accessorKey: "f_ord_d", header: autoTableColumnLabels.f_ord_d, type: 'date', size: 110},
    {accessorKey: "f_vin", header: autoTableColumnLabels.f_vin, type: 'select', size: 160},
    {accessorKey: "f_prd_year", header: autoTableColumnLabels.f_prd_year, type: 'numberInput', size: 70},
    {accessorKey: "f_veh_make", header: autoTableColumnLabels.f_veh_make, type: 'select', size: 100},
    {accessorKey: "f_veh_desc_1", header: autoTableColumnLabels.f_veh_desc_1, type: 'select', size: 100},
    {accessorKey: "f_veh_grp_1", header: autoTableColumnLabels.f_veh_grp_1, type: 'select', size: 140},
    {accessorKey: "f_svo_code_4", header: autoTableColumnLabels.f_svo_code_4, type: 'select', size: 160},
    {accessorKey: "f_svo_code_6", header: autoTableColumnLabels.f_svo_code_6, type: 'select', size: 160},
    {accessorKey: "f_svo_code_8", header: autoTableColumnLabels.f_svo_code_8, type: 'select', size: 180},
    {accessorKey: "f_svo_code_9", header: autoTableColumnLabels.f_svo_code_9, type: 'select', size: 180},
    {accessorKey: "f_supp_2_loc", header: autoTableColumnLabels.f_supp_2_loc, type: 'select', size: 180},
    {accessorKey: "f_supp_2_status_desc", header: autoTableColumnLabels.f_supp_2_status_desc, type: 'select', size: 120},
    {accessorKey: "f_sales_dat", header: autoTableColumnLabels.f_sales_dat, type: 'date', size: 110},
    {accessorKey: "f_sales_cli_o_name", header: autoTableColumnLabels.f_sales_cli_o_name, type: 'select', size: 180},
    {accessorKey: "f_sales_user_name", header: autoTableColumnLabels.f_sales_user_name, type: 'select', size: 120},
    {accessorKey: "f_supp_2_doc_invc_num", header: autoTableColumnLabels.f_supp_2_doc_invc_num, type: 'select', size: 120},
    {accessorKey: "f_supp_2_doc_invc_d", header: autoTableColumnLabels.f_supp_2_doc_invc_d, type: 'date', size: 110},
    {accessorKey: "f_supp_2_doc_invc_mnt", header: autoTableColumnLabels.f_supp_2_doc_invc_mnt, type: 'numberInput', size: 110},
    {accessorKey: "f_sales_xls_sales_mnt", header: autoTableColumnLabels.f_sales_xls_sales_mnt, type: 'numberInput', size: 120},
    {accessorKey: "f_sales_registr", header: autoTableColumnLabels.f_sales_registr, type: 'select', size: 90},
    {accessorKey: "f_sales_registr_dat", header: autoTableColumnLabels.f_sales_registr_dat, type: 'date', size: 90},
    {accessorKey: "f_lief_dat", header: autoTableColumnLabels.f_lief_dat, type: 'date', size: 90},
];

export interface AutoTableInterface {
    id?: string, // Opcjonalne - może być nadpisane przez backend, używamy f_id zamiast tego
    f_id: string, // ID z bazy danych (numeric w DB, string w FE)
    f_supp_2_doc_invc_o_diff: number,
    f_loc_lit: string,
    f_supp_2_loc: string,
    f_vin: string,
    f_prd_year: number,
    f_veh_make: string,
    f_veh_desc_1: string,
    f_veh_grp_1: string,
    f_svo_code_1: string,
    f_svo_code_2: number,
    f_svo_code_3: string,
    f_svo_code_4: string,
    f_svo_code_5: number,
    f_svo_code_6: string,
    f_svo_code_7: string,
    f_svo_code_8: string,
    f_svo_code_9: string,
    f_supp_2_status_desc: string,
    f_sales_dat: string,
    f_sales_cli_o_name: string,
    f_sales_user_name: string,
    f_supp_2_doc_invc_num: string,
    f_supp_2_doc_invc_d: string,
    f_supp_2_doc_invc_mnt: number,
    f_sales_xls_sales_mnt: number,
    f_vis_mark_7: number,
    f_sales_type: string,
    f_sales_registr: string,
    f_sales_registr_dat: string,
    f_lief_dat: string,
    f_ord_num: string,
    f_ord_d: string,
    f_veh_sec_1: string, // Sektor || Sector
    // Pola używane w tabie Sprzedaż (szczegóły) – tylko dane z tabeli Auto
    f_sales_agr_issue_dat?: string,
    f_sales_invc_internal_d?: string,
    f_sales_invc_num?: string,
    f_sales_book_mnt_D?: number | null,
    f_sales_book_mnt_C?: number | null,
}

export interface AutoEqu {
    f_equ_pri_xls_desc_n: string;
}
